import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';

export const useGetQuickbooksOnlineResources = (projectDatabaseId) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['QuickBooksOnlineResources', projectDatabaseId],
    queryFn: async () => {
      return request({
        method: 'get',
        url: `/projects/${projectDatabaseId}/integrations/quick_books_online_resources`,
      });
    },
  });

  return {
    data: data?.data,
    isLoading,
    isError,
  };
};
